import type { Collection } from 'state/utils/types';

export type BackToBackType = 'None' | 'HedgingTrade' | 'ClientTrade';

export interface TradeConfirmationBackToBackFields {
  isBackToBack: boolean;
  backToBackType?: BackToBackType;
  backedNotional?: number;
  fileCode?: string;
  noteNominal?: number;
  isDeltaAdjusted?: boolean;
  isDelayedBackToBack?: boolean;
}

type TradeConfirmationBackToBackMetadata<K extends keyof TradeConfirmationBackToBackFields> = K extends 'backedNotional'
  ? { value: TradeConfirmationBackToBackFields['backedNotional']; isReadonly: boolean; unit: '%' | string }
  : { value: TradeConfirmationBackToBackFields[K]; isReadonly: boolean };

export type TradeConfirmationBackedNotional = TradeConfirmationBackToBackMetadata<'backedNotional'>;

export type TradeConfirmationBackToBack = {
  [K in keyof TradeConfirmationBackToBackFields]: TradeConfirmationBackToBackMetadata<K>;
};

export interface TradeConfirmationState extends TradeConfirmationBackToBack {
  isTrading: boolean;

  hadTraded: boolean;

  hasConfirmedTermsheetDisclaimer: boolean;

  hasConfirmedKidDocumentation: boolean;

  hasConfirmedFrenchPublicOffering: boolean;
}

export const initialTradeConfirmationState: TradeConfirmationState = {
  isTrading: false,
  hadTraded: false,
  hasConfirmedTermsheetDisclaimer: false,
  hasConfirmedKidDocumentation: false,
  hasConfirmedFrenchPublicOffering: false,
  backToBackType: { value: undefined, isReadonly: false },
  backedNotional: { value: undefined, isReadonly: false, unit: '%' },
  fileCode: { value: undefined, isReadonly: false },
  isDeltaAdjusted: { value: undefined, isReadonly: false },
  isDelayedBackToBack: { value: undefined, isReadonly: false },
  isBackToBack: { value: false, isReadonly: false },
  noteNominal: { value: undefined, isReadonly: false },
};

export const defaultBackedNotional: TradeConfirmationBackedNotional = {
  value: undefined,
  isReadonly: false,
  unit: '%',
};

export type TradeConfirmationStateMap = Collection<TradeConfirmationState>;
